import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export function EditDateDialog({ matchday, open, onOpenChange, onSaved }) {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && matchday) {
      setDate((matchday.date || "").slice(0, 10));
      setTime(matchday.time || matchday.matches?.[0]?.time || "15:00");
    }
  }, [open, matchday]);

  const save = async () => {
    if (!date) return toast.error("Seleziona una data");
    setSaving(true);
    try {
      await api.patch(`/matchdays/${matchday.number}/schedule`, { date, time: time || null });
      toast.success(`Giornata ${matchday.number} spostata`);
      onOpenChange(false);
      onSaved?.();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-800 text-slate-100 max-w-sm" data-testid="edit-date-dialog">
        <DialogHeader>
          <DialogTitle className="font-display uppercase tracking-tight">
            Cambia data · Giornata {matchday?.number}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="md-date">Giorno</Label>
            <Input id="md-date" type="date" value={date} onChange={(e) => setDate(e.target.value)}
              className="bg-slate-950 border-slate-700" data-testid="edit-date-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="md-time">Orario (facoltativo)</Label>
            <Input id="md-time" type="time" value={time} onChange={(e) => setTime(e.target.value)}
              className="bg-slate-950 border-slate-700" data-testid="edit-time-input" />
          </div>
          <p className="text-xs text-slate-500">Le coppie e i campi restano invariati.</p>
          <div className="flex justify-end gap-2">
            <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="edit-date-cancel-btn">Annulla</Button>
            <Button onClick={save} disabled={saving} data-testid="edit-date-save-btn"
              className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold">
              {saving && <Loader2 className="w-4 h-4 mr-1.5 animate-spin" />}Salva
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
